import { actions } from 'src/constants';

const initialState = {
  data: {},
  hasLoaded: false,
  isLoading: false,
  isSubmitting: false,
};

const actionMap = {
  [actions.SELECT_STUDENT]: (state, { payload }) => ({
    ...state,
    selectedStudent: payload,
  }),
  [actions.STUDENT_GET_REQUEST]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: true,
  }),
  [actions.STUDENT_GET_SUCCESS]: (state, { result }) => ({
    ...state,
    data: result.data,
    hasLoaded: true,
    isLoading: false,
  }),
  [actions.STUDENT_GET_FAILURE]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: false,
  }),

  [actions.STUDENT_UPDATE_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    hasLoaded: false,
  }),
  [actions.STUDENT_UPDATE_SUCCESS]: (state, { result }) => ({
    ...state,
    data: result.data,
    isSubmitting: false,
    hasLoaded: true,
  }),
  [actions.STUDENT_UPDATE_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    hasLoaded: false,
  }),

  [actions.STUDENT_COLLECTION_UNLOCK_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
  }),
  [actions.STUDENT_COLLECTION_UNLOCK_SUCCESS]: (state) => ({
    ...state,
    isSubmitting: false,
  }),
  [actions.STUDENT_COLLECTION_UNLOCK_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
  }),

  [actions.ADD_STUDENT_TO_USER_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
  }),
  [actions.ADD_STUDENT_TO_USER_SUCCESS]: (state) => ({
    ...state,
    isSubmitting: false,
  }),
  [actions.ADD_STUDENT_TO_USER_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};
